var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7014 20C16.7014 20 21.0549 18.3465 23.3503 13.3071C19.6301 13.3071 16.7014 10.315 16.7014 6.69291C16.7014 2.99213 19.7092 0 23.3503 0C26.9914 0 29.9992 2.99213 29.9992 6.69291C30.0784 14.0158 24.1419 20 16.7014 20ZM0 20C0 20 4.35345 18.3465 6.6489 13.3071C2.92868 13.3071 0 10.315 0 6.69291C0 2.99213 3.00784 0 6.72806 0C10.4483 0 13.377 2.99213 13.377 6.69291C13.377 14.0158 7.44044 20 0 20Z",
    fill: "#F3F3F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.27972dad366538f8fe9435fa1d2f8489.svg";
export { ForwardRef as ReactComponent };